import { Control } from "react-hook-form";
import Tabs from "ui/components/Tabs";
import { Flex, Box } from "@chakra-ui/react";
import ContabilizacaoTable from "../ContabilizacaoTable";
import ItemResumo from "./ItemResumo/index";
import ProvisaoTable from "./ProvisaoTable/index";
import moment from "moment";

export default function FormResumo({
  control,
}: {
  control: Control<any, object>;
}) {
  const dataProvisao = [
    {
      id: "1",
      dataProvisao: "10/10/2023",
      provisoes: [
        {
          id: "1",
          debito: 1,
          credito: 1,
          historico: "Safe2pay instituicao de pagamento ltda",
          valor: 10.14,
        },
        {
          id: "2",
          debito: 1,
          credito: 1,
          historico: "Safe2pay instituicao de pagamento ltda",
          valor: 10.14,
        },
        {
          id: "3",
          debito: 1,
          credito: 1,
          historico: "Safe2pay instituicao de pagamento ltda",
          valor: 10.14,
        },
        {
          id: "4",
          debito: 1,
          credito: 1,
          historico: "Safe2pay instituicao de pagamento ltda",
          valor: 10.14,
        },
      ],
    },
    {
      id: "2",
      dataProvisao: "10/10/2023",
      provisoes: [
        {
          id: "2",
          debito: 1,
          credito: 1,
          historico: "Safe2pay instituicao de pagamento ltda",
          valor: 10.14,
        },
      ],
    },
    {
      id: "3",
      dataProvisao: "10/10/2023",
      provisoes: [
        {
          id: "3",
          debito: 1,
          credito: 1,
          historico: "Safe2pay instituicao de pagamento ltda",
          valor: 10.14,
        },
      ],
    },
  ];

  const ResumoRealizado = [
    {
      id: "1",
      nome: "SICOOB",
      saldoFinal: 1000,
      realizado: [
        {
          id: "1",
          dataRealizado: "20/10/2023",
          saldo: 100,
          historicoContaBancaria: [
            {
              id: "1",
              debito: 1,
              credito: 1,
              historico: "historico",
              valor: 1014.4,
              saldoParcial: 14111,
            },
            {
              id: "2",
              debito: 1,
              credito: 1,
              historico: "historico",
              valor: 1014.4,
              saldoParcial: 14111,
            },
          ],
        },
        {
          id: "2",
          dataRealizado: "20/10/2023",
          saldo: 100,
          historicoContaBancaria: [
            {
              id: "1",
              debito: 1,
              credito: 1,
              historico: "historico",
              valor: 1014.4,
              saldoParcial: 14111,
            },
            {
              id: "2",
              debito: 1,
              credito: 1,
              historico: "historico",
              valor: 1014.4,
              saldoParcial: 14111,
            },
          ],
        },
      ],
    },
    {
      id: "2",
      nome: "SICOOB",
      saldoFinal: 1000,
      realizado: [
        {
          id: "1",
          dataRealizado: "20/10/2023",
          saldo: 100,
          historicoContaBancaria: [
            {
              id: "1",
              debito: 1,
              credito: 1,
              historico: "historico",
              valor: 1014.4,
              saldoParcial: 14111,
            },
            {
              id: "2",
              debito: 1,
              credito: 1,
              historico: "historico",
              valor: 1014.4,
              saldoParcial: 14111,
            },
          ],
        },
        {
          id: "2",
          dataRealizado: "20/10/2023",
          saldo: 100,
          historicoContaBancaria: [
            {
              id: "1",
              debito: 1,
              credito: 1,
              historico: "historico",
              valor: 1014.4,
              saldoParcial: 14111,
            },
            {
              id: "2",
              debito: 1,
              credito: 1,
              historico: "historico",
              valor: 1014.4,
              saldoParcial: 14111,
            },
          ],
        },
      ],
    },
  ];

  return (
    <Tabs.Tab
      containerProps={{
        padding: 0,
        roundedBottom: 16,
      }}
    >
      <Tabs.Panel title="Realizado">
        <ContabilizacaoTable
          borderTopRadius={0}
          headerTable={
            <Flex w="100%" gap={6} alignItems="center">
              <Flex flex={12} fontWeight="medium">
                Conta bancária
              </Flex>
              <Flex
                fontWeight="medium"
                align="center"
                gap={1}
                ml="auto"
                textAlign="right"
              >
                Saldo final
              </Flex>
            </Flex>
          }
          rowTable={ResumoRealizado.map((item) => (
            <Box w="100%">
              <ItemResumo
                title={item.nome}
                total={item.saldoFinal}
                table={item.realizado.map((realizado) => (
                  <Box w="100%">
                    <ItemResumo
                      bg="white"
                      mt="0"
                      title={realizado.dataRealizado}
                      total={realizado.saldo}
                      table={
                        <ProvisaoTable
                          saldoParcial
                          items={realizado.historicoContaBancaria}
                        />
                      }
                    />
                  </Box>
                ))}
              />
            </Box>
          ))}
        />
      </Tabs.Panel>

      <Tabs.Panel title="Provisionado">
        <ContabilizacaoTable
          borderTopRadius={0}
          headerTable={
            <Flex w="100%" gap={6}>
              <Flex flex={3} fontWeight="medium">
                Data da provisão
              </Flex>
            </Flex>
          }
          rowTable={dataProvisao.map((item) => (
            <Box w="100%">
              <ItemResumo
                key={item.id}
                title={moment(item.dataProvisao).format("DD/MM/YYYY")}
                table={<ProvisaoTable items={item.provisoes} />}
              />
            </Box>
          ))}
        />
      </Tabs.Panel>
    </Tabs.Tab>
  );
}
